import ArcaneApiGateway from '@/services/arcane-api-gateway';

export default {
  install: (app) => {
    const {
      config: { globalProperties },
    } = app;
    app.provide('arcaneApiGateway', new ArcaneApiGateway(globalProperties));
  },
};
